export default __webpack_public_path__ + "static/das_holding-1da325211e1a8175fe41f905a40de331.png";